import React, { Component } from "react";
import { connect } from "react-redux";

import { setPopup } from "../actions/siteActions";

class SendRequestButton extends Component {
  openSendRequestForm = () => {
    //console.log("open request form");
    this.props.setPopup("request-password", true);
  };
  render() {
    return (
      <button className="button secondary" type="button" onClick={() => this.openSendRequestForm()}>
        Parooli saamiseks kirjuta meile
      </button>
    );
  }
}

const mapStateToProps = (state) => ({
  site: state.site,
});

export default connect(mapStateToProps, { setPopup })(SendRequestButton);
